import { LearningOpportunityType } from "@/server/backend-api/generated";

export const AttendingSectionStatic = {
  initialHelpText: {
    [LearningOpportunityType.Challenge]:
      "This is your team space for this challenge. Here you can see the other learners, teamchers and other relevant information about the challenge.",
    [LearningOpportunityType.MicroModule]:
      "This is your space for this micro-module. Here you can see the other learners, teachers and other relevant information about the micro-module.",
  },
  teacherHeader: {
    [LearningOpportunityType.Challenge]: "Teamchers",
    [LearningOpportunityType.MicroModule]: "Teaching staff",
  },
  teacherTeamMemberLabel: {
    [LearningOpportunityType.Challenge]: "Teamcher",
    [LearningOpportunityType.MicroModule]: "Teacher",
  },
  teacherInfoText: {
    [LearningOpportunityType.Challenge]:
      "These are the teamchers you'll work with on the challenge.",
    [LearningOpportunityType.MicroModule]:
      "Meet the expert teaching staff, who is here to guide you through this learning opportunity.",
  },
  workspace: {
    title: "The workspace",
    text: {
      [LearningOpportunityType.MicroModule]: {
        ["active"]: "This is the workspace for your micro-module.",
        ["disabled"]:
          "This is the workspace for your micro-module. It will be available a couple of days before the module starts.",
      },
      [LearningOpportunityType.Challenge]: {
        ["active"]:
          "This is the place where you and your team work together to solve the challenge.",
        ["disabled"]:
          "This is the place where you and your team will work together to solve the challenge. It will be available a couple of days before the challenge starts.",
      },
    },
  },
};

export const MetaAndInfoSectionStatic = {
  teamHeader: {
    [LearningOpportunityType.Challenge]: "The team",
    [LearningOpportunityType.MicroModule]: "The team",
  },
};
